export default "__VITE_ASSET__DegkC3y0__"